import { compose, withStateHandlers, lifecycle } from 'recompose'
import { dispatchEvents } from 'sidecar-utility-library'
import { sizes as screenSizes } from 'sidecar-design-library'

export default compose(
  withStateHandlers(({ viewPort = null }) => ({ viewPort }), {
    handleResize: () => () => {
      const { innerWidth } = window
      const { mobile, tablet, laptop, desktop } = screenSizes

      // yes, viewPort will get set multiple times, but
      // it should be quick and it'll be accurate.
      let viewPort
      if (innerWidth < mobile[1]) viewPort = 'mobile'
      if (innerWidth > mobile[0]) viewPort = 'mobile'
      if (innerWidth > tablet[0]) viewPort = 'tablet'
      if (innerWidth > laptop[0]) viewPort = 'laptop'
      if (innerWidth > desktop[0]) viewPort = 'desktop'
      return { viewPort }
    },
  }),
  lifecycle({
    componentDidMount() {
      // Mount listener for width changes
      window.addEventListener('resize', this.props.handleResize)
      dispatchEvents('resize')
    },
    componentWillUnmount() {
      // Remove listener for width changes
      window.removeEventListener('resize', this.props.handleResize)
    },
  }),
)
